import axios from "axios";

import type { Team, UserTeam } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export type UserTeamWithTeam = UserTeam & { team: Team };

export async function getUserTeamsByCompanyFn() {
	const response = await axios.get<UserTeamWithTeam[]>(`${env.apiUrl}/user-teams/company`);

	return response.data;
}

export const deleteUserTeamById = async ({ id }: { id: string }) => {
	await axios.delete(`${env.apiUrl}/user-teams/${id}`);

	return id;
};

export const createUserTeam = async ({ userId, teamId }: { userId: string; teamId: string }) => {
	const response = await axios.post<UserTeamWithTeam>(`${env.apiUrl}/user-teams`, {
		userId,
		teamId,
	});

	return response.data;
};

export const getUserTeamsByCompany = queryOptions({
	queryKey: "userTeams",
	queryFn: getUserTeamsByCompanyFn,
});
